"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictListing = void 0;
var React = require("react");
var styles_1 = require("@/pages/guides/components/DistrictListing/styles");
var recompose_1 = require("recompose");
var react_measure_1 = require("react-measure");
var DistrictItem_1 = require("@/pages/guides/components/DistrictItem/DistrictItem");
var enhance = recompose_1.compose(recompose_1.withState('width', 'setWidth', 100));
var Component = function (_a) {
    var guidesDistricts = _a.guidesDistricts, width = _a.width, setWidth = _a.setWidth;
    var imageUrl = guidesDistricts.imageUrl, districts = guidesDistricts.districts;
    var onResize = function (contentRect) { return setWidth(contentRect.bounds.width); };
    var image = function (params) { return (React.createElement(styles_1.Image, { ref: params.measureRef, style: { height: width * 0.35172, backgroundImage: "url(" + imageUrl + ")" } })); };
    var renderDistricts = function () { return (districts.map(function (district) { return (React.createElement(DistrictItem_1.DistrictItem, { key: district.districtId, districtItem: district })); })); };
    return (React.createElement(styles_1.Container, null,
        React.createElement(react_measure_1.default, { bounds: true, onResize: onResize }, image),
        React.createElement("div", { style: { height: 20 } }),
        React.createElement(styles_1.ListingContainer, null, renderDistricts())));
};
exports.DistrictListing = enhance(Component);
